import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    width={17 * (props.wx ?? 1)}
    height={25 * (props.hx ?? 1)}
    viewBox="0 0 17 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <mask
      id="path-1-outside-1_2045_327"
      maskUnits="userSpaceOnUse"
      x="0.532227"
      y="0.289917"
      width="16"
      height="24"
      fill="black"
    >
      <rect fill="white" x="0.532227" y="0.289917" width="16" height="24" />
      <path d="M8.532 22.7166C9.73087 22.7166 12.8486 24.2301 14.6494 22.3388C16.0925 20.8231 15.5595 17.1781 14.525 14.7254C14.1403 13.8128 14.116 12.9444 14.1322 11.9597C14.2079 7.28008 15.7933 1.29209 14.6566 1.28992C13.5199 1.28775 12.0318 13.0499 8.532 13.1699C5.03223 13.2899 5.53223 8.76991 5.03223 6.56992C4.53223 4.36992 3.84848 1.28992 3.15662 1.28992C2.46475 1.28992 2.53941 4.36993 2.53941 5.24992C2.53941 6.1299 2.88921 9.86608 2.84036 11.9597C2.81738 12.9444 2.92417 13.8132 2.53941 14.7254C1.50498 17.1786 0.971986 20.8235 2.41506 22.3388C4.21585 24.2301 7.33312 22.7166 8.532 22.7166Z" />
    </mask>
    <path
      d="M8.532 22.7166C9.73087 22.7166 12.8486 24.2301 14.6494 22.3388C16.0925 20.8231 15.5595 17.1781 14.525 14.7254C14.1403 13.8128 14.116 12.9444 14.1322 11.9597C14.2079 7.28008 15.7933 1.29209 14.6566 1.28992C13.5199 1.28775 12.0318 13.0499 8.532 13.1699C5.03223 13.2899 5.53223 8.76991 5.03223 6.56992C4.53223 4.36992 3.84848 1.28992 3.15662 1.28992C2.46475 1.28992 2.53941 4.36993 2.53941 5.24992C2.53941 6.1299 2.88921 9.86608 2.84036 11.9597C2.81738 12.9444 2.92417 13.8132 2.53941 14.7254C1.50498 17.1786 0.971986 20.8235 2.41506 22.3388C4.21585 24.2301 7.33312 22.7166 8.532 22.7166Z"
      fill={props.fill || '#E4E4E7'}
    />
    <path
      d="M8.532 22.7166C9.73087 22.7166 12.8486 24.2301 14.6494 22.3388C16.0925 20.8231 15.5595 17.1781 14.525 14.7254C14.1403 13.8128 14.116 12.9444 14.1322 11.9597C14.2079 7.28008 15.7933 1.29209 14.6566 1.28992C13.5199 1.28775 12.0318 13.0499 8.532 13.1699C5.03223 13.2899 5.53223 8.76991 5.03223 6.56992C4.53223 4.36992 3.84848 1.28992 3.15662 1.28992C2.46475 1.28992 2.53941 4.36993 2.53941 5.24992C2.53941 6.1299 2.88921 9.86608 2.84036 11.9597C2.81738 12.9444 2.92417 13.8132 2.53941 14.7254C1.50498 17.1786 0.971986 20.8235 2.41506 22.3388C4.21585 24.2301 7.33312 22.7166 8.532 22.7166Z"
      stroke={props.stroke || '#A1A1AA'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      mask="url(#path-1-outside-1_2045_327)"
    />
  </svg>
);
export default SvgNormal;
